/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrNumericColumn } from './igr-numeric-column';
import { NumericColumn } from './NumericColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrNumericColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrNumericColumnModule() {
    }
    IgrNumericColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrNumericColumn", IgrNumericColumn);
        TypeRegistrar.register("NumericColumn", NumericColumn.$type);
    };
    return IgrNumericColumnModule;
}());
export { IgrNumericColumnModule };
//# sourceMappingURL=igr-numeric-column-module.js.map
